module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/landing-hero-nos-7aa58cc5ccbb383fe180da99ec6c9b21.svg";